"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingResultsForOptions = exports.nightlyPricesForAverage = exports.averagePriceForPercentageOfRange = exports.maxPriceFactor = exports.minPriceFactor = void 0;
const pricing_generator_helpers_1 = require("./pricing-generator-helpers");
const diem_1 = __importDefault(require("@travelnest/diem"));
const weekdayPriceFactor = 1;
const weekendPriceFactor = 1.21;
const sundayPriceFactor = 1.16;
exports.minPriceFactor = 0.75;
exports.maxPriceFactor = 1.25;
const averagePriceForPercentageOfRange = (minPrice, maxPrice, percentage, stdPrice) => {
    // Treat minPrice -> stdPrice as one scale,
    // and stdPrice -> maxPrice as a 2nd.
    // i.e. 75% percentage overall would be
    // 100% of minPrice -> stdPrice, and
    // 50% of stdPrice -> maxPrice
    if (percentage > 50) {
        let outputPrice = stdPrice;
        const remainingPercentage = (percentage - 50) * 2 * 0.01;
        return outputPrice += (maxPrice - stdPrice) * remainingPercentage;
    }
    else {
        let outputPrice = minPrice;
        return outputPrice += (stdPrice - minPrice) * (percentage * 2 * 0.01);
    }
};
exports.averagePriceForPercentageOfRange = averagePriceForPercentageOfRange;
const nightlyPricesForAverage = (avgPrice) => {
    const weekdayPrice = Math.round(avgPrice * weekdayPriceFactor);
    const weekendPrice = Math.round(avgPrice * weekendPriceFactor);
    const sundayPrice = Math.round(avgPrice * sundayPriceFactor);
    return {
        mon: weekdayPrice,
        tue: weekdayPrice,
        wed: weekdayPrice,
        thu: weekdayPrice,
        fri: weekendPrice,
        sat: weekendPrice,
        sun: sundayPrice
    };
};
exports.nightlyPricesForAverage = nightlyPricesForAverage;
const pricingResultsForOptions = (propertyId, pricingOptions, fromDate = (new diem_1.default())) => {
    const dateRanges = (0, pricing_generator_helpers_1.nextMonthDateRanges)(fromDate);
    const results = [];
    dateRanges.forEach((range) => {
        const monthName = (0, pricing_generator_helpers_1.monthNameForIndex)(new diem_1.default(range.start_date).getMonth());
        const templatePricingPercentage = (0, pricing_generator_helpers_1.percentageForMonthInTemplate)(monthName, pricingOptions.seasonality);
        const averageNightlyPrice = Math.round((0, exports.averagePriceForPercentageOfRange)(pricingOptions.min_price, pricingOptions.max_price, templatePricingPercentage, pricingOptions.standard_price));
        const period = {
            property_id: propertyId,
            name: (0, pricing_generator_helpers_1.nameForPricingPeriodFromDate)(new diem_1.default(range.start_date)),
            start_date: range.start_date,
            end_date: range.end_date,
            min_stay: pricingOptions.min_stay,
            seven_night_discount: 0,
            twenty_eight_night_discount: 0,
            arrival_days: pricingOptions.arrival_days,
            departure_days: pricingOptions.departure_days,
            prices: (0, exports.nightlyPricesForAverage)(averageNightlyPrice),
            managed_by: 'portal',
            currency: pricingOptions.currency
        };
        results.push({
            averagePrice: averageNightlyPrice,
            pricingPeriod: period,
            percentage: templatePricingPercentage
        });
    });
    return results;
};
exports.pricingResultsForOptions = pricingResultsForOptions;
exports.default = exports.pricingResultsForOptions;
//# sourceMappingURL=pricing-generator.js.map